<span [ngSwitch]="loaderType">
  <div *ngSwitchCase="'card'" class="custom-overlay-container">
    <div class="custom-overlay-section">
      <mat-progress-spinner
        class="section-loader"
        [color]="color"
        [mode]="mode"
        [value]="value"
      >
      </mat-progress-spinner>
      <p *ngIf="loaderMsg" class="loader-msg">
       Loading, please wait.
      </p>
    </div>
  </div>

  <div *ngSwitchCase="'fullScreenLoader'" class="loader">
    <mat-progress-spinner
      class="page-loader"
      [color]="color"
      [mode]="mode"
      [value]="value"
    >
    </mat-progress-spinner>
  </div>
</span>
